var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.Service}},[_c('TableText',{attrs:{"prop":"user_id","label":"用户ID","width":260}}),_c('TableText',{attrs:{"prop":"user.nickname","label":"用户昵称","width":260}}),_c('TableAction',{attrs:{"buttons":[
    { name: '删除' }
  ],"minWidth":160}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }